import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Page } from '../../layout/AppLayout.jsx'
import { useCompany } from '../../context/CompanyContext.jsx'

/* Wraps a former admin-console tab as a standalone, super-admin-only page so it
 * can live directly in the sidebar menu. */
export default function AdminScreen({ titleKey, children }) {
  const { t } = useTranslation()
  const { isSuperAdmin } = useCompany()
  if (!isSuperAdmin()) return <Navigate to="/app/dashboard" replace />
  return <Page title={t(titleKey)}>{children}</Page>
}
